var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuarantorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#FFF3CE",
    stroke: "#FBEB96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 18.6673H18.666V20.0007H13.3327V18.6673ZM13.3327 16.0007H18.666V17.334H13.3327V16.0007ZM17.3327 9.33398H11.9993C11.266 9.33398 10.666 9.93398 10.666 10.6673V21.334C10.666 22.0673 11.2593 22.6673 11.9927 22.6673H19.9993C20.7327 22.6673 21.3327 22.0673 21.3327 21.334V13.334L17.3327 9.33398ZM19.9993 21.334H11.9993V10.6673H16.666V14.0007H19.9993V21.334Z",
    fill: "#AA8305"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantorIcon);
export default __webpack_public_path__ + "static/media/guarantor_icon.0a3afe19b62d8917ee579891a765fb87.svg";
export { ForwardRef as ReactComponent };